// extracted by mini-css-extract-plugin
module.exports = {"openingHours":"OpeningHours_openingHours__kkQoP"};